module.exports = __webpack_public_path__ + "img/x431_2.652d9746.jpg";